import gql from "graphql-tag";

export const MY_LEAVE_CREATE_REPEATED_HO_REQUEST = gql`
  mutation createRepeatedHOLeaveRequest(
    $contract: String!
    $type: String!
    $weekDays: [Int!]!
    $repeatedStartDate: Date!
    $repeatedEndDate: Date!
    $locale: String!
    $message: String
    $isAssigner: Boolean
  ) {
    createRepeatedHOLeaveRequest(
      contract: $contract
      type: $type
      weekDays: $weekDays
      repeatedStartDate: $repeatedStartDate
      repeatedEndDate: $repeatedEndDate
      locale: $locale
      message: $message
      isAssigner: $isAssigner
    ) {
      success
      count
    }
  }
`;
